import { useTranslations } from 'next-intl';
import { TrashIcon } from '@mentimeter/ragnar-visuals';
import { DropdownMenuItem } from '@mentimeter/ragnar-ui/menu';
import { ModalRoot, ModalTrigger } from '@mentimeter/ragnar-ui/modal';
import { Text } from '@mentimeter/ragnar-ui/text';

export const DeleteActionModalTrigger = ({
  onOpenDeleteModalChange,
}: {
  onOpenDeleteModalChange: () => void;
}) => {
  const t = useTranslations('creation.comments');
  return (
    <ModalRoot onOpenChange={onOpenDeleteModalChange}>
      <ModalTrigger>
        <DropdownMenuItem flexDirection="row" alignItems="center">
          <TrashIcon color="negative" />
          <Text ml="space2" color="negative" fontSize="87.5">
            {t('comments_delete_modal_trigger_button')}
          </Text>
        </DropdownMenuItem>
      </ModalTrigger>
    </ModalRoot>
  );
};
